const APP_SETTINGS = {
    PAGE_SIZE: 20
}

export default APP_SETTINGS